import React, { Component } from "react";
import styles from "./routes.module.scss";
import RoutesList from "./RoutesList";
import CreateRoute from "./CreateRoute";
import FilterAndSearchTools from "../FilterTools/FilterAndSearchTools";
import { withLogisticRoutes } from "../../../shared/containers/containerLogisticRoutes";

const viewPanelItems = {
  routeList: "routeList",
  createRoute: "createRoute",
};

class Routes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewPanel: viewPanelItems.routeList,
    };
  }

  componentDidMount() {
    const routeId = window.location.pathname.replace("/logistic/routes", "");

    if (routeId !== "" && routeId !== "/") {
      this.setState({ viewPanel: viewPanelItems.createRoute });
    }
  }

  onSetViewPanel(viewPanel) {
    this.setState({ viewPanel });
  }

  render() {
    const { viewPanel } = this.state;
    const { onGetLogisticRoutes } = this.props;
    const setViewPanel = this.onSetViewPanel.bind(this);

    return (
      <div className={styles.routesPanelContainer}>
        {viewPanel === viewPanelItems.routeList ? (
          <FilterAndSearchTools onFilter={onGetLogisticRoutes} titleSearch="Поиск по маршрутам " />
        ) : null}

        {viewPanel === viewPanelItems.routeList ? <RoutesList viewPanelItems={viewPanelItems} onSetViewPanel={setViewPanel} /> : null}

        {viewPanel === viewPanelItems.createRoute ? <CreateRoute viewPanelItems={viewPanelItems} onSetViewPanel={setViewPanel} /> : null}
      </div>
    );
  }
}

export default withLogisticRoutes(React.memo(Routes));
